import React from "react";
import PropTypes from "prop-types";
import { TabContainer, TabText } from "./TabStyles.js";

const Tab = ({ label, isActive, id, handleTabClick }) => {
  return (
    <TabContainer isActive={isActive} onClick={() => handleTabClick(id)}>
      <TabText isActive={isActive}>{label}</TabText>
    </TabContainer>
  );
};

Tab.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  isActive: PropTypes.bool,
  handleTabClick: PropTypes.func,
};

export default Tab;
